import { ROUTES, USER_ROLES } from 'shared/consts';

const INVESTORS_ROUTES = {
  path: ROUTES.INVESTORS,
  shortcut: 'Inwst',
  userRole: USER_ROLES.INVESTOR,
};

export default INVESTORS_ROUTES;
